export default {
  // 媒体号入驻申请时获取媒体号分类树
  getSelfmediaCategoryTreeForApply: '/member/anonymous/amc/selfMedia/getSelfmediaCategoryTreeForApply',
  // 省市地址
  getTotalAmcAreaList: '/member/anonymous/amc/getTotalAmcAreaList',
  // 媒体号入驻申请，提交申请信息
  addApplyForSelfMediaFreChannel: '/member/anonymous/amc/selfMedia/addApplyForSelfMediaFreChannel',
  // 媒体号入驻申请，获取申请列表
  listApplyForSelfMediaFreChannel: '/member/anonymous/amc/selfMedia/listApplyForSelfMediaFreChannel',
  // 媒体号入驻申请，修改申请信息
  updateApplyForSelfMediaFreChannel: '/member/anonymous/amc/selfMedia/updateApplyForSelfMediaFreChannel',
  // 媒体号入驻申请，删除申请
  delApplyForSelfMediaFreChannel: '/member/anonymous/amc/selfMedia/delApplyForSelfMediaFreChannel',
  // 媒体号入驻申请，驳回修改后再次提交申请
  backForSubmit: '/member/anonymous/amc/selfMedia/backForSubmit',

}